import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { Sort } from './sort.model';
import { TableHeader } from './table-header.model';

export const TABLE_SCHEMA = Object.freeze({
  TITLE: '',
  SUMMARIES: List<string>([]),
  SORT_BY: null,
  HEADERS: List<TableHeader>([]),
  ROWS: List<List<string | number>>(List([])),
  URLS: List<List<string>>(List([])),
  FOOTERS: List<List<string | number>>(List([])),
});
const RECORD = generateSchema(TABLE_SCHEMA);
const KEYS: any = generateKeys(TABLE_SCHEMA);

export class Table extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.HEADERS,
        value: props.get(KEYS.HEADERS)
          ? List(this.headers).map((params) => new TableHeader(params))
          : List<TableHeader>([]),
      },
      {
        key: KEYS.SUMMARIES,
        value: props.get(KEYS.SUMMARIES) ? List(this.summaries) : null,
      },
      {
        key: KEYS.SORT_BY,
        value: props.get(KEYS.SORT_BY) ? new Sort(this.sortedBy) : null,
      },
    ]);

    return selfModel as Table;
  }

  get title(): string {
    return this.get(KEYS.TITLE);
  }

  get summaries(): List<string> {
    return this.get(KEYS.SUMMARIES);
  }

  // NOTE: can't use `sort()` or `sortBy()` because they are used by immutable lib
  get sortedBy(): Sort {
    return this.get(KEYS.SORT_BY);
  }

  get headers(): List<TableHeader> {
    return this.get(KEYS.HEADERS);
  }

  get rows(): List<List<string | number>> {
    return this.get(KEYS.ROWS);
  }

  get urls(): List<List<string>> {
    return this.get(KEYS.URLS);
  }

  get footers(): List<List<string | number>> {
    return this.get(KEYS.FOOTERS);
  }

  getTypeForHeader(headerIndex: number) {
    return this.headers.get(headerIndex).type;
  }
}
